import React from "react";
import SvgInfo from "../../Icons/NotificationMessage/Info";
import styles from "./EmptyScheduleMessage.module.css";

interface EmptyScheduleMessageProps {
  style?: React.CSSProperties;
}
const EmptyScheduleMessage = (props: EmptyScheduleMessageProps) => {
  return (
    <div className={styles.container} style={props.style}>
      <SvgInfo color="#2F80ED" height={34} width={34} />
      No schedule selected
    </div>
  );
};

export default EmptyScheduleMessage;
